module.exports = __webpack_public_path__ + "img/homePageH.7e69f78d.png";